import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import quizData from "../../data/home.json";
import questionsData from "../../data/questions.json";
import articleData from "../../data/financeFacts.json";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import FactsSection from "../../components/FactsSection";
import AdComponent from "../../components/AdComponent";
const Join = () => {
    const { id } = useParams();
    const user = useSelector((state) => state.user.user);
    const navigate = useNavigate();
    const [category, setCategory] = useState({});
    const [article, setArticle] = useState({});

    useEffect(() => {
        if(id){
            const category = quizData.find((c) => c.id === id);
            setCategory(category);
            const article = articleData?.PAGE2 || {};
            setArticle(article);
        }
    }, [id]);

    const prizeTiers = {
        rank_1: 1.0,
        rank_2_10: 0.5,
        rank_11_50: 0.267,
        rank_51_200: 0.133,
        rank_201_500: 0.067,
        rank_501_1000: 0.033
    };

    const handleClick = (e) => {
        e.preventDefault();
        // const confirmStart = window.confirm(`Are you sure you want to start this quiz? Entry fee of ${category?.entry_fee} coins will be deducted.`);
        // if (confirmStart) {
            const question = questionsData.filter((q) => q.category_id === id);
            if(question.length === 0){
                toast.error('No questions available for this quiz.');
            } else {
                if(user?.coins < category?.entry_fee){
                    toast.error('You do not have enough coins to start this quiz.');
                } else {
                    navigate(`/quiz/start/${category?.id}`);
                }
            }
        // }
    };
    
    if(!id){
        navigate('/');
    }

    return(
        <>
            <section className="play-quiz-section">
                <div className="container">
                    <div className="play-quiz-card quiz-coin-play">
                        <div className="play-quiz-icon">
                            <img src="/assets/images/card-3.png" alt="Loans and Cards" />
                        </div>
                        <h4 className="play-quiz-category">{category?.topic_name}</h4>
                        <h2 className="play-quiz-title d-flex align-items-center justify-content-center gap-2">Play and Win {category?.winner_coins}
                            <span className="coin">
                                <img src="/assets/images/dollar.png" alt="coin" />
                            </span>
                        </h2>
                        <p className="play-quiz-desc">
                            You’ve got 60 seconds to answer all questions. 
                            Answer as many questions as you can. Entry fee will be {category?.entry_fee} 
                            <span className="coin">
                                <img src="/assets/images/dollar.png" alt="coin" />
                            </span>
                        </p>
                        <p className="play-quiz-note mb-2">
                            Join and save the coins you win! Its free & safe!
                        </p>
                    </div> 
                    <div className="play-quiz-actions">
                        <button type="button" className="btn-guest btn new-btn" onClick={(e) => handleClick(e)}>Play</button>
                    </div>
                </div>
            </section>

            <section className="quizz-btn-section pt pb">
                <div className="container">
                    <div className="quizz-btn-wrap d-flex align-items-center gap-3">
                        <Link to={"#"} className="btn-guest btn new-btn" id="openPrizeBtn">View Prize</Link>
                        <Link to="/rules" className="btn-guest btn new-btn" >Rules</Link>
                    </div>
                </div>
            </section>
            <AdComponent />
            <section className="facts-section">
                <div className="container">
                    <div className="finance-fact">
                        <h2 className="fw-bold mb-4">{article?.title}</h2>
                    </div>
                    {
                        article?.content?.map((item, index) => (
                            <FactsSection key={index} item={item} />
                        ))
                    }
                    <div className="article-card">
                        <h2 className="article-card-title">{article?.action?.title}</h2>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title1}</strong> {article?.action?.desc1}
                        </p>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title2}</strong> {article?.action?.desc2}
                        </p>
                        
                        <p className="article-card-desc">
                            {
                                article?.action?.list.map((list, index) => (
                                    <><span key={index}>{list}</span><br /></>
                                ))
                            }
                        </p>
                    </div>
                </div>
            </section>

            {/* Prize Popup */}
            <div className="prize-popup-overlay" id="prizePopup">
                <div className="prize-popup">
                    <div className="prize-popup-header d-flex align-items-center justify-content-between">
                        <h3>Prize Rank List</h3>
                        <button className="popup-close" id="closePrizeBtn">&times;</button>
                    </div>
                    <div className="prize-popup-body">
                        <ul>
                            <li><span>Rank 1</span><strong>{Math.floor((category?.winner_coins ?? 0) * prizeTiers['rank_1'])}<span className="coin"><img src="/assets/images/dollar.png" alt="coin" /></span> </strong></li>
                            <li><span>Rank 2 - 10</span><strong>{Math.floor((category?.winner_coins ?? 0) * prizeTiers['rank_2_10'])}<span className="coin"><img src="/assets/images/dollar.png" alt="coin" /></span> </strong></li>
                            <li><span>Rank 11 - 50</span><strong>{Math.floor((category?.winner_coins ?? 0) * prizeTiers['rank_11_50'])}<span className="coin"><img src="/assets/images/dollar.png" alt="coin" /></span> </strong></li>
                            <li><span>Rank 51 - 200</span><strong>{Math.floor((category?.winner_coins ?? 0) * prizeTiers['rank_51_200'])}<span className="coin"><img src="/assets/images/dollar.png" alt="coin" /></span> </strong></li>
                            <li><span>Rank 201 - 500</span><strong>{Math.floor((category?.winner_coins ?? 0) * prizeTiers['rank_201_500'])}<span className="coin"><img src="/assets/images/dollar.png" alt="coin" /></span> </strong></li>
                            <li><span>Rank 501 - 1000</span><strong>{Math.floor((category?.winner_coins ?? 0) * prizeTiers['rank_501_1000'])}<span className="coin"><img src="/assets/images/dollar.png" alt="coin" /></span> </strong></li>
                        </ul>
                    </div>
                </div>
            </div> 
        </>
    )
}

export default Join;